module.exports = __webpack_public_path__ + "img/Botton.d91bc2a8.svg";